<template>
  <main v-if="data">
    <div class="banner">
      <div class="swiper-slide">
        <router-link
          :to="item.slideMLink"
          v-for="(item, index) in data.listimg"
          :key="index"
          :style="{ backgroundImage: `url(${item.slideImg})` }"
          :title="item.slideAlt"
          class="swiper-content"
        >
        </router-link>
      </div>

    </div>

    <div class="main-title" >
      Contact
    </div>

    <div class="position-info">

      <p>Tel：+86-400-6699833</p>
      <p>Email : Info@bncc.com</p>
      <p>Address：No.15 Jianguo Rd, Chaoyang District, Beijing, P.R.China</p>
      <div class="contract-wapper">
        <a
          href="https://tb.53kf.com/code/client/670c56f26e85ec66df9d068b5c2cd2531/2"
          class="inline"
        >
          <img src="@/assets/img/about/icon98.png" alt="" />
          Online customer service
        </a>
      </div>
    </div>
    <div class="block" style="height: 11rem;">
      <div class="block-title">
        <div class="main-title" style="    margin-bottom: 0.4rem;">
          Company Profile
        </div>
        <p>
          BNCC is a high-tech enterprise integrating R&D, production and application. With a building area of 10000 square meters, it can provide: standard strains, quantitative strains, cell lines, plasmids/competent cells, genomic DNA, biomass control products, detection kits, culture media and reagents, technical services, etc.
        </p>
      </div>
      <div class="video-wapper">

        <video
          id="player-container-id"
          poster="https://1300465694.vod2.myqcloud.com/8d629ce8vodcq1300465694/0cdfa52d387702305401815693/387702305401815694.png"
          src="https://1300465694.vod2.myqcloud.com/8d629ce8vodcq1300465694/0cdfa52d387702305401815693/z6ARqA2WvVEA.mp4"
          style="width: 100%; height: 100%"
          playsinline
          webkit-playinline
          x5-playinline
          controls
          autoplay
        ></video>
      </div>
    </div>
    <div class="block">
      <div class="block-title border-bottom-1px">
        Account Information<br />
      </div>
      <div class="account-info">
        <ul>
          <li>
            <p style="padding: 0">BENEFICAIRY: SHANGCHENG BEINACHUANGLIAN BIOTECHNOLOGY COMPANY LIMITED</p>
            <p>BENEFICIARY BANK： CHINA CONSTRUCTION BANK XINYANG BR</p>
            <p>BENEFICIARY BANK ADDRESS： NO.178，ZHONG SHAN RD, XINYANG, HENAN, CHINA</p>
            <p>BENEFICIARY BANK SWIFT CODE:  PCBCCNB JHAX</p>
          </li>

        </ul>
      </div>
    </div>
    <div class="tip-block">

      <div class="tip">
        <span> BNCC was founded in 2010</span>
<!--        <p>国家标准物质研制单位 标准物质一站式采购平台</p>-->
        <p>
          60000+
          Microbial products
        </p>
        <p>
          24000m²+
          Scientific research base
        </p>
      </div>

    </div>
    <div class="development-history">
      <div class="dev-title">Time Certificate Our Efforts</div>
      <div class="dev-list">
        <p>July 2010</p>
        <p>
          BNCC was established, focusing on the field of cells and microbial strains, a bio-high-tech enterprise integrating R&D, production and sales.
        </p>
      </div>
      <div class="dev-list">
        <p>August 2015</p>
        <p>
          BNCC Kunshan Laboratory was established, realizing the transformation from a sales platform to a biological research and development enterprise.

        </p>
      </div>
      <div class="dev-list">
        <p>May 2018
        </p>
        <p>
          More than ten new patents were applied for. Advanced equipment and professional talents will provide you with better technical support.
        </p>
      </div>

      <div class="dev-list">
        <p>
          November 2018
        </p>
        <p>
          BNCC settled in the light industrial park, and the laboratory expansion project was officially completed, which greatly improved the technical standards and operating environment for the R&D and production of cells and strains.

        </p>
      </div>
      <div class="dev-list">
        <p>January 2019
        </p>
        <p>
          BNCC passed the ISO9001 quality system certification and obtained the certification.
        </p>
      </div>
      <div class="dev-list">
        <p>April 2019</p>
        <p>
          The BNCC scientific research base started construction. In the near future, domestic first-class strain and cell laboratories, molecular biology laboratories, culture medium production lines, microbial testing centers, and e-commerce centers will be built soon.
        </p>
      </div>
      <div class="dev-list">
        <p>July 2019</p>
        <p>The BNCC quantitative strain research and development project was successfully completed.
        </p>
      </div>

      <div class="dev-list">
        <p>November 2019</p>
        <p>BNCC successfully developed DH5α competent cells.
        </p>
      </div>
      <div class="dev-list">
        <p>March 2020</p>
        <p>
          BNCC was rated as a high-tech enterprise in Henan Province.
        </p>
      </div>

      <div class="dev-list">
        <p>April 2020</p>
        <p>BNCC successfully passed the audit to join the Chinese Society for Microbiology and became a full member.</p>
      </div>

      <div class="dev-list">
        <p>October 2020</p>
        <p>
          The joint application of Weiye Metrology and Yunan Testing Center was successful, and 77 kinds of national secondary standard substances were approved!

        </p>
      </div>
      <div class="dev-list">
        <p>November 2020

        </p>
        <p>
          BNCC was successfully approved for the construction of the Xinyang Key Laboratory of Molecular and Cell Biology.

        </p>
      </div>
      <div class="dev-list">
        <p>December 2020
        </p>
        <p>BNCC's first batch of bacterial genomic DNA research and development projects were successfully completed.
        </p>
      </div>

      <div class="dev-list">
        <p>
          December 2020
        </p>
        <p>
          The Henan Industrial Microbiology Engineering Technology Research Center successfully settled in BNCC.
        </p>
      </div>

      <div class="dev-list">
        <p>
          June 2021
        </p>
        <p>
          BNCC successfully developed a new spore suspension, equipped with a COA traceability certificate and identification report.
        </p>
      </div>

      <div class="dev-list">
        <p>
          July 2021
        </p>
        <p>
          BNCC successfully developed the reference material for the total number of bacterial colonies in food.
        </p>
      </div>


      <div class="dev-list">
        <p>July 2021
        </p>
        <p>
          Weiye  successfully declared 28 kinds of national primary reference materials.
        </p>
      </div>
      <div class="dev-list">
        <p>
          August 2021
        </p>
        <p>
          BNCC  release a new product - standard quality control product for the determination of fecal coliform bacteria, to meet the needs of customers in terms of method verification, quality control, and personnel assessment during the standard application process.

        </p>
      </div>

      <div class="dev-list">
        <p>November 2021
        </p>
        <p>
          BNCC launched a self-developed reagent: DEPC treated water, which can be used for the dissolution of nucleic acid precipitation, various reaction systems containing nucleic acid.

        </p>
      </div>

      <div class="dev-list">
        <p>November 2021
        </p>
        <p>
          The BNCC scientific research base will be officially completed and put into production, with a construction area of 10,000 square meters and an experimental area of 4,000 square meters.
        </p>
      </div>
      <div class="dev-list">
        <p>December 2021
        </p>
        <p>
          Weiye successfully developed and passed the  review of 34 kinds of standard materials for the analysis of biological elements.

        </p>
      </div>
      <div class="dev-list">
        <p>December 2021
        </p>
        <p>
          Weiye  successfully declared 18 national secondary reference materials.

        </p>
      </div>
      <div class="dev-list">
        <p>October 2020
        </p>
        <p>Weiye successfully declared 77 kinds of national secondary-class reference
          materials
        </p>
      </div>
      <div class="dev-list">
        <p>December 2021
        </p>
        <p>
          BNCC developed a series of quality control products for self-developed water quality testing.
        </p>
      </div>

      <div class="dev-list">
        <p>
          December 2021
        </p>
        <p>
          BNCC launched the self-developed N gene pseudovirus nucleic acid quality control product of the new coronavirus.
        </p>
      </div>

      <div class="dev-list">
        <p>January 2022
        </p>
        <p>
          BNCC launched self-developed coliform count quality control products.
        </p>
      </div>
      <div class="dev-list">
        <p>January 2022
        </p>
        <p>
          Weiye was approved again for 14 national secondary reference materials.
        </p>
      </div>

      <div class="dev-list">
        <p>November 2021
        </p>
        <p>
          Beina Biological Research Base was officially completed and put into
          production,
          10,000㎡ construction and 4,000㎡ experimental area were built.
        </p>
      </div>
      <div class="dev-list">
        <p>
          March 2022
        </p>
        <p>
          BNCC successfully developed a quality control product for the determination of DNA content in CHO cells.
        </p>
      </div>
      <div class="dev-list">
        <p>
          April 2022

        </p>
        <p>
          BNCC successfully developed fungal nucleic acid detection kits and chicken-derived nucleic acid detection kits.

        </p>
      </div>
    </div>
  </main>
  <loading :options="loadOption" v-else></loading>
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  inject,
  nextTick,
  watch,
  onUnmounted,
} from "vue";
import axios from "@/api/axios";
import Toast from "@/components/UI/Toast";
import Loading from "@/components/UI/Loading";
import Swiper from "swiper";
import asyncLoadJs from "@/hooks/useAsyncLoadJs";

import Modal from "@/components/UI/Modal";
export default defineComponent({
  name: "About",
  components: {
    Loading,
  },
  setup() {
    const data = ref(null);
    // nextTick(() => {
    //   asyncLoadJs(
    //     "//imgcache.qq.com/open/qcloud/video/tcplayer/lib/hls.min.0.8.8.js",
    //     "about"
    //   ).then(() => {
    //     asyncLoadJs(
    //       "//imgcache.qq.com/open/qcloud/video/tcplayer/tcplayer.min.js",
    //       "about"
    //     ).then((res) => {
    //       vTCPlayer("player-container-id", "387702295832720318",true);
    //       // vTCPlayer("player-bncc-id", "387702293224742253",true);
    //       vTCPlayer("playerContentVideo", "5285890792153886246",true);
    //     });
    //   });
    // })
    const userInfo = inject("userInfo") as any;

    axios
      .get("/M/Home/About")
      .then((res) => {
        if (res.data.success) {
          const kefulist = [];
          const length = Math.ceil(res.data.obj.kefulist.length / 6);
          for (let i = 0; i < length; i++) {
            kefulist.push(res.data.obj.kefulist.slice(i * 6, i * 6 + 6));
          }
          data.value = { ...res.data.obj, kefulist };

        } else {
          Toast({
            type: "error",
            title: res.data.msg,
          });
        }
      })
      .catch((err) => {
        console.log("err");
      });

    watch(data, () => {
      nextTick(() => {
        const swiper = new Swiper(".swiper-container", {
          initialSlide: 0,
          autoplay: true,
          loop: true,
          observer: true, //修改swiper自己或子元素时，自动初始化swiper
          observeParents: true, //修改swiper的父元素时，自动初始化swiper
          on: {
            observerUpdate: function () {
              this.slideTo(0);
            },
          },
          pagination: {
            el: ".swiper-pagination",
          },
        });
      });
    });



    const loadOption = {
      text: "Loading...",
      color: "#df0024",
      textColor: "#df0024",
    };
    return {
      data,
      loadOption,
    };
  },
});
</script>


<style lang="scss" scoped>
.banner {
  margin-bottom: 0.533rem;
}
.banner .swiper-content {
  width: 100%;
  height: 4rem;
  display: block;
  position: relative;
  overflow: hidden;
  background-size: cover;
  background-position: center center;
}

.banner .swiper-content img {
  /*width: 100%;*/
  height: 4rem;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  display: block;
}

.banner .swiper-container {
  --swiper-theme-color: #fff;
  /* 设置Swiper风格 */
  --swiper-navigation-color: #fff;
  /* 单独设置按钮颜色 */
  --swiper-navigation-size: 1.067rem;
  /* 设置按钮大小 */
  --swiper-pagination-color: #df0024;
  /* 两种都可以 */
}

.banner .my-bullet {
  display: inline-block;
  width: 0.347rem;
  height: 0.067rem;
  background-color: #ffffff;
  margin: 0 0.067rem;
  border-radius: 0;
  opacity: 1;
}

.banner .my-bullet-active {
  background-color: #df0024;
}

.free-tel-model {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10000;
  display: none;
}

.free-tel-wapper {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 90%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  line-height: 1.5;
  background-color: rgba(255, 255, 255, 0.95);
  border-radius: 0.267rem;
  z-index: 10001;
  display: none;
}
.free-tel-title {
  padding: 0.533rem 0.533rem 0.267rem;
  margin-bottom: -0.667rem;
  text-align: center;
  font-size: 0.467rem;
  font-weight: 400;
  color: #333;
}

#callMeTel {
  margin-left: 0.533rem;
  width: 87%;
  height: 1.067rem;
  line-height: 1.067rem;
  border: 0.027rem solid #c10728;
  padding-left: 0.267rem;
  outline: none;
}

.free-tel-btn {
  border-top: 0.027rem solid #eee;

  font-size: 0;
  margin-top: 0.533rem;
}
.free-tel-btn span {
  display: inline-block;
  height: 1.173rem;
  line-height: 1.173rem;
  color: #007aff;
  font-size: 0.453rem;
  font-weight: 400;
  cursor: pointer;
  text-decoration: none;
  background-color: transparent;
  width: 50%;
  text-align: center;
  zoom: 1;
  box-sizing: border-box;
}

.free-tel-btn .free-tel-cancel {
  color: #999;
}
.free-tel-confirm {
  border-left: 0.027rem solid #eee;
}

.free-tel-tip {
  padding: 0.533rem 0.533rem 0.267rem;
  font-size: 0.28rem;
}

main {
  padding-bottom: 1.333rem;
}

.main-title {
  font-size: 0.46rem;
  color: #444444;
  font-weight: bold;
  width: 9.467rem;
  margin: 0 auto;
  border-bottom: 0.027rem solid #eee;
  padding-bottom: 0.1rem;
}

.main-title span {
  text-transform: uppercase;
  font-size: 10px;
  color: #666;
  font-weight: normal;
  position: relative;
  top: -5px;
}

.position-info {
  font-size: 0.4rem;
  color: #666;
  line-height: 0.64rem;
  padding: 0.2rem 0.267rem 0.2rem 0;
  width: 9.467rem;
  box-sizing: border-box;
  margin: 0 auto;
}
.position-info p {
  margin: 0;
}
.contract-wapper {
  margin-top: 0.533rem;
  display: flex;
  justify-content: space-between;
}
.contract-wapper a {
  display: inline-block;
  /*width: 3.733rem;*/
  height: 1.067rem;
  line-height: 1.067rem;
  text-align: left;
  font-size: 0.427rem;
  border: 0.027rem solid #e5e5e5;
  border-radius: 0.133rem;
  padding: 0 0.25rem;
  box-sizing: border-box;
  color: #666;
}





.contract-wapper img {
  width: 0.467rem;
  height: 0.48rem;
  vertical-align: middle;
  margin-right: 0.333rem;
}

.block {
  border-top: 0.16rem solid #eee;
  padding: 0.2rem 0.267rem;
  border-bottom: 0.027rem solid #eee;
}

.block-title {
  font-size: 0.46rem;
  color: #444444;
  font-weight: bold;
  /*padding-bottom: 10px;*/
  /*border-bottom: 0.027rem solid #eee;*/
}

.block-title p {
  font-size: 14px;
  color: #666;
  font-weight: normal;
  /*text-transform: uppercase;*/
  margin: 0.1rem 0 0;

}

.border-bottom-1px {
  border-bottom: 0.027rem solid #eee;
}

.custom-service {
  width: 9.467rem;
  margin: 0 auto;
  padding: 0.533rem 0;
}
.custom-service-ul {
  padding-bottom: 2.133rem;
  overflow: hidden;
}
.custom-service-ul li {
  float: left;
  width: 49%;
  padding-left: 1.52rem;
  margin: 0;
  margin-bottom: 5px;
  box-sizing: border-box;
  position: relative;
  font-size: 0.293rem;
  line-height: 0.48rem;
  color: #666;
}

.custom-service-ul li img {
  width: 1.253rem;
  height: 1.253rem;
  border-radius: 50%;
  position: absolute;
  top: 0;
  left: 0;
}

.custom-service-ul li span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}
.account-info li {
  border-bottom: 0.027rem solid #eee;
  padding: 0.533rem 0;
}

.account-info p {
  font-size: 0.4rem;
  line-height: 0.587rem;
  color: #444444;
  margin: 0 auto;
}

.create-img {
  width: 100%;
  display: block;
}

.tip {
  width: 100%;
  height: 6rem;
  background-color: #df0024;
  text-align: center;
  font-size: 0.533rem;
  color: #fff;
  padding-top: 1.6rem;
  box-sizing: border-box;
  font-weight: bold;
}

.tip p {
  font-size: 0.4rem;
  color: #fff;
  margin-top: 0.4rem;
  font-weight: normal;
  text-align: left;
  padding-left: 1.5rem;
}

.tip-container p {
  font-size: 0.4rem;
  color: #444444;
  line-height: 0.587rem;
  margin-top: 0.267rem;
  text-indent: 2em;
}

.tip-container a {
  color: #df0024;
}

.development-history {
  border-top: 0.16rem solid #eee;
  padding: 0.667rem 0.4rem 0 ;
}
.dev-title {
  text-align: center;
  font-size: 0.46rem;
  font-weight: bold;
  color: #444444;
}

.dev-desc {
  font-size: 0.4rem;
  color: #444444;
  margin-top: 0.4rem;
  font-weight: bold;
  text-align: center;
}

.dev-list {
  font-weight: normal;
  font-size: 0.427rem;
  color: #444444;
  border-bottom: 0.027rem solid #eee;
}

.dev-list p {
  margin: 1em 0;
}

.video-wapper {
  width: 9.467rem;
  height: 5.333rem;
  margin: 0.4rem auto;
}

  .video_title{
    font-size: 0.36rem;
    color: #444444;
    margin: 0 auto;
    padding-left: 0;
  }
</style>
